// main.jsx
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
import { ScreenProvider } from "./context/ScreenProvider.jsx"
import { UserFilesProvider } from './context/UserFilesProvider.jsx';
import { FilterProvider } from './context/FilterProvider.jsx';

import App from './App.jsx';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID,
      userPoolId: import.meta.env.VITE_USER_POOL_ID
    }
  }
})

const root = createRoot(document.getElementById("root"));

// wrap the application with AuthProvider
root.render(
  // TODO remove strict mode after testing
  <React.StrictMode> 
    <Authenticator.Provider>
      <UserFilesProvider>
        <ScreenProvider>
          <FilterProvider>
            <App />
          </FilterProvider>
        </ScreenProvider>
      </UserFilesProvider>
    </Authenticator.Provider>
  </React.StrictMode>
);
